import DropdownMenu from './DropdownMenu.vue';
import FormSubheader from './FormSubheader.vue';

import Vue from 'vue';

Vue.component('subheader', () => import('./FormSubheader'));
Vue.component('FormSubheader', () => import('./FormSubheader'));
Vue.component('Popup', () => import('./popup'));
Vue.component('Popup2', () => import('./popup/index2.vue'));
Vue.component('EditField', () => import('./editField'));
Vue.component('AppTable', () => import('./appTable'));
Vue.component('tablePage', () => import('../layouts/PageLayoutTable'));
Vue.component('AppEntity', () => import('./app-entity'));

export { DropdownMenu, FormSubheader };
